import { Component, OnDestroy } from '@angular/core';

@Component({
	selector: 'app-vax-status',
	templateUrl: './vax-status.component.html',
	styleUrls: ['./vax-status.component.scss'],
})
export class VaxStatusComponent {}
